import * as React from 'react';
import {
  IAddonsProps,
  IInputProps,
  IInputSearchProps,
  IProps,
} from '../common/props';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { InputAddons } from '../input-addons/InputAddons';
import { inputFieldSeachOnKeyDown } from '../common/utils';
import { InputGroup, InputGroupProps } from '../input-group/InputGroup';
export interface IStringInputProps
  extends IProps,
    IInputProps,
    IInputSearchProps,
    IAddonsProps,
    InputGroupProps {
  children?: React.ReactNode;
}

export type StringInputProps = IStringInputProps &
  React.InputHTMLAttributes<HTMLInputElement>;

/**
 * Komponenta pro editaci jenořádkového textu..
 */
export class StringInput extends React.PureComponent<StringInputProps> {
  render() {
    const {
      className,
      onSearch,
      addonAfter,
      addonAfterCompact,
      disabled,
      readOnly,
      dataTest,
      ...other
    } = this.props;
    const input = (
      <InputGroup
        data-test={dataTest ? `input-${dataTest}` : undefined}
        onKeyDown={inputFieldSeachOnKeyDown(onSearch)}
        className={classNames(
          className,
          Classes.FIELD_INPUT,
          Classes.STRING_INPUT,
          {
            [Classes.FIELD_INPUT_DISABLED]: disabled,
            [Classes.FIELD_INPUT_READONLY]: readOnly,
          }
        )}
        {...other}
        disabled={disabled}
        readOnly={readOnly}
      />
    );

    return (
      <InputAddons
        addonAfter={addonAfter}
        addonAfterCompact={addonAfterCompact}
      >
        {input}
      </InputAddons>
    );
  }
}
